import React, { Component } from "react";

const CurveUp = ({ width,height,fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} 70`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_17486:18392)">
        <path
          d={`M${width} 26.289V69.5625H0V26.289C0 26.289 95.3056 8.5625 180 8.5625C264.694 8.5625 ${width} 26.289 ${width} 26.289Z`}
          fill={fill}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_17486:18392"
          x="-4"
          y="0.5625"
          width={width + 8}
          height={height - 1}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-4" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_17486:18392"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_17486:18392"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

CurveUp.defaultProps = {
  fill: "white",
  width: 360,
  height: 70,
};

export default CurveUp;
